import { useEffect, useState } from 'react';

// This hook tracks a viewport-derived value and updates it on resize.
// The argument can be any function from 'src/client/utils/device.ts', such as device.getBreakpoint,
// device.isTabletOrMobile, device.isMobile, etc.
const useViewportValue = <T,>(getCurrentViewportValue: () => T) => {
  const [currentViewportValue, setCurrentViewportValue] = useState(getCurrentViewportValue());

  useEffect(() => {
    const handleResize = () => {
      setCurrentViewportValue(getCurrentViewportValue());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [getCurrentViewportValue]);

  return currentViewportValue;
};

export default useViewportValue;
